module.exports = __webpack_public_path__ + "img/card-default.2453d5b0.svg";